import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import ENDPOINTS from "@/constants/endpoints"

export type SmartRoutingPeriod = {
  type: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY"
  description: string
}

type SmartRoutingPeriodsResponse = {
  periods: SmartRoutingPeriod[]
}

export const useSmartRoutingPeriods = () => {
  return useQuery({
    queryKey: ["smart-routing-periods"],
    queryFn: async () => {
      const { data } =
        await api.get<SmartRoutingPeriodsResponse>(
          ENDPOINTS.SMART_ROUTING_PERIODS
        )
      return data.periods || []
    },
    staleTime: 1000 * 60 * 60, // 1 hora - períodos não mudam com frequência
  })
}
